import { ApolloError } from '@apollo/client';

import { BillingInfoFragmentFragment, useGetOrganizationBillingInfoQuery } from 'data/__generated__';

type UseOrganizationBillingInfoResult = {
    billingInfo: BillingInfoFragmentFragment | null;
    isBillingInfoLoading: boolean;
    billingInfoError: ApolloError | undefined;
    refetchBillingInfo: () => void;
};

// Les infos de facturation sont la propriété d'Odoo (`res.partner`) : elles se chargent dans une requête
// À PART de celle de l'organisation. Conséquences voulues :
//   - la latence Odoo ne s'ajoute plus au chargement de l'orga (donc au boot de l'app) ;
//   - une panne Odoo dégrade UNIQUEMENT la section facturation, qui affiche son propre message d'erreur.
// Apollo dédoublonne la requête entre tous les composants qui appellent ce hook (un seul appel réseau).
export function useOrganizationBillingInfo(): UseOrganizationBillingInfoResult {
    const { data, loading, error, refetch } = useGetOrganizationBillingInfoQuery();

    return {
        billingInfo: data?.organizationOfUser?.billingInfo ?? null,
        isBillingInfoLoading: loading,
        billingInfoError: error,
        refetchBillingInfo: () => {
            void refetch();
        },
    };
}
